import { Injectable } from '@angular/core';
import { SFStorageKeyConstant } from 'projects/bo/src/app/shared/constants/sf-storage-key.constant';
import { StorageStateService } from '../abstracts/storage-state-service.abstract';
import { DashboardMetricList } from '../api/dashboard/dashboard.model';

@Injectable({
  providedIn: 'root'
})
export class DashboardMetricsState extends StorageStateService<DashboardMetricList[]> {
  constructor() {
    super(SFStorageKeyConstant.DashboardMetricList);
  }
}
